module.exports = __webpack_public_path__ + "img/ylb-en10.0ddc46f5.png";